export default __webpack_public_path__ + "static/media/Korjo.0c97d6c0.svg";